export function logSelectedTemplate(incomingTemplateUid: string, selectedTemplateKey: string): void {
  console.info(
    `[PageTemplate] selected template "${selectedTemplateKey}" for incoming templateUid "${incomingTemplateUid}".`,
  );
}

export function warnMissingSlot(templateUid: string, requestedPosition: string): void {
  console.warn(
    `[PageTemplate] template "${templateUid}" requested slot position "${requestedPosition}" that was not provided in metadata.slots.`,
  );
}

export function warnUnplacedSlots(templateUid: string, unplacedPositions: string[]): void {
  if (unplacedPositions.length === 0) {
    return;
  }
  console.warn(
    `[PageTemplate] metadata.slots sent position(s) [${unplacedPositions.join(
      ", ",
    )}] that template "${templateUid}" did not place.`,
  );
}

export function failUnknownTemplate(incomingTemplateUid: string): void {
  console.error(`[PageTemplate] unknown templateUid "${incomingTemplateUid}" — no registered page template.`);
}
